import ImgOne from '../images/h5.jpg';
import ImgTwo from '../images/h6.jpg';

export const InfoDataOne = {
    heading: 'explore our beautiful homes',
    paragraphOne: 'Lit amet, consectetur adipisicing elit. Autem, commodi distinctio error expedita illo incidunt non odio pariatur perspiciatis praesentium reiciendis repudiandae sint sit, vel, voluptatem. Aliquid non perspiciatis tempore.',
    paragraphTwo: 'Folor sit amet, consectetur adipisicing elit. Autem, commodi distinctio error expedita illo incidunt non odio pariatur perspiciatis praesentium reiciendis repudiandae sint sit, vel, voluptatem. Aliquid non perspiciatis tempore.',
    buttonLabel: 'View Homes',
    image: ImgOne,
    reverse: false,
    delay: 100
}


export const InfoDataTwo = {
    heading: 'Modern Designs',
    paragraphOne: 'Werspiciatis praesentium reiciendis repudiandae sint sit, vel, voluptatem. Aliquid non perspiciatis tempore.',
    paragraphTwo: 'Qarror expedita illo incidunt non odio pariatur perspiciatis praesentium reiciendis repudiandae sint sit, vel, voluptatem. Aliquid non perspiciatis tempore.',
    buttonLabel: 'View Homes',
    image: ImgTwo,
    reverse: true,
    delay: 300
}

